module.exports = __webpack_public_path__ + "media/site/images/banners/banner-development-tablet-7f7a7857846c340ad2b40dff32b3336a.svg";